import { ByteArrayInput } from "@opendaw/lib-std";
import { BoxGraphCopy } from "../../BoxGraphCopy";
export var ClipboardUtils;
(function (ClipboardUtils) {
    ClipboardUtils.extractMetadata = (data) => {
        const input = new ByteArrayInput(data);
        const metadataLength = input.readInt();
        const metadataBytes = new Int8Array(metadataLength);
        input.readBytes(metadataBytes);
        return metadataBytes.buffer;
    };
    // serializeBoxes/deserializeBoxes moved to BoxGraphCopy (they touch no clipboard). Re-exported
    // here so the existing copy/paste handlers keep using ClipboardUtils unchanged.
    ClipboardUtils.serializeBoxes = BoxGraphCopy.serializeBoxes;
    ClipboardUtils.deserializeBoxes = BoxGraphCopy.deserializeBoxes;
})(ClipboardUtils || (ClipboardUtils = {}));
